// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';

export const TextHolder = styled.div`
  width: 100%;
  font-size: 14px;
  line-height: 22px;

  p {
    margin: 0 0 30px;
  }
`;

export const BtnHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;
